<template>
  <el-dialog title="移表" z-index="990" :visible.sync="yDialogVisible" :close-on-click-modal="false" width="1000px">

    <div style="max-height: 700px;overflow-y: auto;">

      <div style="width: 100%">
        <el-descriptions style="width: 100%" title="" :column="1" direction="vertical" size="mini" border>
          <el-descriptions-item label="仪表信息">
            <el-descriptions class="margin-top" title="" :column="2" size="mini" border :labelStyle="{width: '100px'}" :contentStyle="{width:'43%'}">
              <el-descriptions-item label="仪表编号">
                <el-input size="mini" class="form-input" v-model="meter_data.number" autocomplete="off" disabled></el-input>
              </el-descriptions-item>
              <el-descriptions-item label="仪表名称">
                <el-input size="mini" class="form-input" v-model="meter_data.name" autocomplete="off" disabled></el-input>
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>

          <el-descriptions-item label="仪表移表">
            <el-descriptions title="" :column="2" direction="vertical" size="mini" border>
              <el-descriptions-item label="仪表现所在房产和收费对象">
                <div>现所在房产:</div>
                <el-table
                  :data="meter_list_1"
                  style="width: 100%">
                  <el-table-column
                    prop="customer_name"
                    label="仪表现收费对象"
                    width="120">
                  </el-table-column>
                  <el-table-column
                    prop="proportion"
                    label="承担比率"
                    width="100">
                  </el-table-column>
                  <el-table-column
                    prop="remarks"
                    label="备注">
                  </el-table-column>
                </el-table>
              </el-descriptions-item>
              <el-descriptions-item label="仪表新房产和收费对象">
                <div>移到新房产:</div>
                <div>
                  <el-button size="mini" @click="add">添加</el-button>
                  <el-button size="mini" @click="remove">移除</el-button>
                </div>
                <el-table
                  :data="meter_list_2"
                  style="width: 100%" @selection-change="handleSelectionChange">
                  <el-table-column
                    type="selection"
                    width="55">
                  </el-table-column>
                  <el-table-column
                    prop="customer_name"
                    label="仪表现收费对象"
                    width="120">
                    <template slot-scope="scope">
                      <el-link type="primary" @click="selectUser(scope.row)">{{scope.row.customer_name||"选择对象"}}</el-link>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="proportion"
                    label="承担比率"
                    width="100">
                    <template slot-scope="scope">
                      <el-input size="mini" class="form-input" v-model="scope.row.proportion"  autocomplete="off"></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="remarks"
                    label="备注">
                    <template slot-scope="scope">
                      <el-input size="mini" class="form-input" v-model="scope.row.remarks" autocomplete="off"></el-input>
                    </template>
                  </el-table-column>
                </el-table>
              </el-descriptions-item>
            </el-descriptions>
          </el-descriptions-item>
        </el-descriptions>

        <ErpRoomUser ref="ErpRoomUser" />
      </div>

    </div>

    <div slot="footer" class="dialog-footer">
      <el-button @click="yDialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitAll()">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import ErpRoomUser from "../Common/ErpRoomUser";
export default {
  name: "MeterShifting",
  components: {ErpRoomUser},
  data(){
    return{
      meter_data:{},
      yDialogVisible:false,
      meter_list_1:[],//{customer_id:"",customer_name:"",proportion:1,remarks""}
      meter_list_2:[],
      multipleSelection:[]
    }
  },
  created() {

  },
  computed:{
    meter_list_2_all_proportion(){
      return this.meter_list_2.reduce(function(total, currentValue, currentIndex){
        total+=(currentValue.proportion*1);
        return total;
      }, 0)
    }
  },
  methods:{
    show(data){
      this.yDialogVisible=true;
      this.meter_data=data;
      this.getList();
    },
    getList() {
      var that = this;
      let where = {
        meter_id:that.meter_data.id,
      };
      ERP.getRequest({
        url: "admin/MeterChangeObj/getList",
        data: {
          where: JSON.stringify(where),
          page: 1,
          page_size: 100
        }
      }, res => {
        if (res.code) {
          that.meter_list_1 = reObject(res.data.list)
          that.meter_list_2 = reObject(res.data.list.map(ret=>{
            ret.id=undefined;
            return ret;
          }))
        }
      })
    },
    add(){
      var that=this;
      that.meter_list_2.push({
        temp_id:(new Date).getTime().toString(),
        meter_id:that.meter_data.id,
        customer_name:"",
        customer_id:"",
        proportion:1 - that.meter_list_2_all_proportion,
        remarks:""
      });
    },
    remove(){
      var that=this;
      that.multipleSelection.map(ret=>{
        let index=that.meter_list_2.findIndex(re=>{ return re.temp_id===ret.temp_id })
        that.meter_list_2.splice(index,1);
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    selectUser(item){
      var that=this;
      that.$refs.ErpRoomUser.show(user=>{
        item.customer_name=user.name;
        item.customer_id=user.id;
      })
    },
    setFrom(data){
      var that = this;
      ERP.postRequest({url: "admin/MeterChangeObj/save", data: data}, res => {
        if (!res.code) {
          that.$message.error(res.msg||"数据提交异常")
        }
      })
    },
    submitAll(){
      var that=this;
      //先删除
      ERP.postRequest({
        url:"admin/MeterChangeObj/delete",
        data:{
          ids:that.meter_list_1.map(ret=>{ return ret.id }).join(',')
        }
      },res => {
        that.meter_list_2.map(ret=>{
          that.setFrom(ret)
        })
        that.yDialogVisible=false
      })

    }

  }
}
function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>

<style lang="scss" scoped>
.form-input{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/SecpMeter/MeterShifting.vue